module.exports = __webpack_public_path__ + "fr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/fr.svg
// module id = 551
// module chunks = 0